//
// WARNING: this file was auto-generated by @phensley/cldr-compiler. DO NOT EDIT.
//

/** @public */
export type LanguageIdType = (
  'aa'| 'ab'| 'ace'| 'ach'| 'ada'| 'ady'| 'ae'| 'aeb'| 'af'| 'afh'| 'agq'
| 'ain'| 'ak'| 'akk'| 'akz'| 'ale'| 'aln'| 'alt'| 'am'| 'an'| 'ang'| 'ann'
| 'anp'| 'apc'| 'ar'| 'ar-001'| 'arc'| 'arn'| 'aro'| 'arp'| 'arq'| 'ars'
| 'arw'| 'ary'| 'arz'| 'as'| 'asa'| 'ase'| 'ast'| 'atj'| 'av'| 'avk'| 'awa'
| 'ay'| 'az'| 'az-Arab'| 'ba'| 'bal'| 'ban'| 'bar'| 'bas'| 'bax'| 'bbc'| 'bbj'
| 'be'| 'bej'| 'bem'| 'bew'| 'bez'| 'bfd'| 'bfq'| 'bg'| 'bgc'| 'bgn'| 'bho'
| 'bi'| 'bik'| 'bin'| 'bjn'| 'bkm'| 'bla'| 'blo'| 'blt'| 'bm'| 'bn'| 'bo'
| 'bpy'| 'bqi'| 'br'| 'bra'| 'brh'| 'brx'| 'bs'| 'bss'| 'bua'| 'bug'| 'bum'
| 'byn'| 'byv'| 'ca'| 'cad'| 'car'| 'cay'| 'cch'| 'ccp'| 'ce'| 'ceb'| 'cgg'
| 'ch'| 'chb'| 'chg'| 'chk'| 'chm'| 'chn'| 'cho'| 'chp'| 'chr'| 'chy'| 'cic'
| 'ckb'| 'clc'| 'co'| 'cop'| 'cps'| 'cr'| 'crg'| 'crh'| 'crj'| 'crk'| 'crl'
| 'crm'| 'crr'| 'crs'| 'cs'| 'csb'| 'csw'| 'cu'| 'cv'| 'cy'| 'da'| 'dak'
| 'dar'| 'dav'| 'de'| 'de-AT'| 'de-CH'| 'del'| 'den'| 'dgr'| 'din'| 'dje'
| 'doi'| 'dsb'| 'dtp'| 'dua'| 'dum'| 'dv'| 'dyo'| 'dyu'| 'dz'| 'dzg'| 'ebu'
| 'ee'| 'efi'| 'egl'| 'egy'| 'eka'| 'el'| 'elx'| 'en'| 'en-AU'| 'en-CA'
| 'en-GB'| 'en-US'| 'enm'| 'eo'| 'es'| 'es-419'| 'es-ES'| 'es-MX'| 'esu'| 'et'
| 'eu'| 'ewo'| 'ext'| 'fa'| 'fa-AF'| 'fan'| 'fat'| 'ff'| 'fi'| 'fil'| 'fit'
| 'fj'| 'fo'| 'fon'| 'fr'| 'fr-CA'| 'fr-CH'| 'frc'| 'frm'| 'fro'| 'frp'| 'frr'
| 'frs'| 'fur'| 'fy'| 'ga'| 'gaa'| 'gag'| 'gan'| 'gay'| 'gba'| 'gbz'| 'gd'
| 'gez'| 'gil'| 'gl'| 'glk'| 'gmh'| 'gn'| 'goh'| 'gon'| 'gor'| 'got'| 'grb'
| 'grc'| 'gsw'| 'gu'| 'guc'| 'gur'| 'guz'| 'gv'| 'gwi'| 'ha'| 'hai'| 'hak'
| 'haw'| 'hax'| 'he'| 'hi'| 'hi-Latn'| 'hif'| 'hil'| 'hit'| 'hmn'| 'hnj'| 'ho'
| 'hr'| 'hsb'| 'hsn'| 'ht'| 'hu'| 'hup'| 'hur'| 'hy'| 'hz'| 'ia'| 'iba'| 'ibb'
| 'id'| 'ie'| 'ig'| 'ii'| 'ik'| 'ikt'| 'ilo'| 'inh'| 'io'| 'is'| 'it'| 'iu'
| 'izh'| 'ja'| 'jam'| 'jbo'| 'jgo'| 'jmc'| 'jpr'| 'jrb'| 'jut'| 'jv'| 'ka'
| 'kaa'| 'kab'| 'kac'| 'kaj'| 'kam'| 'kaw'| 'kbd'| 'kbl'| 'kcg'| 'kde'| 'kea'
| 'ken'| 'kfo'| 'kg'| 'kgp'| 'kha'| 'kho'| 'khq'| 'khw'| 'ki'| 'kiu'| 'kj'
| 'kk'| 'kkj'| 'kl'| 'kln'| 'km'| 'kmb'| 'kn'| 'ko'| 'koi'| 'kok'| 'kos'
| 'kpe'| 'kr'| 'krc'| 'kri'| 'krj'| 'krl'| 'kru'| 'ks'| 'ksb'| 'ksf'| 'ksh'
| 'ku'| 'kum'| 'kut'| 'kv'| 'kw'| 'kwk'| 'kxv'| 'ky'| 'la'| 'lad'| 'lag'
| 'lah'| 'lam'| 'lb'| 'lez'| 'lfn'| 'lg'| 'li'| 'lij'| 'lil'| 'liv'| 'lkt'
| 'lld'| 'lmo'| 'ln'| 'lo'| 'lol'| 'lou'| 'loz'| 'lrc'| 'lsm'| 'lt'| 'ltg'
| 'lu'| 'lua'| 'lui'| 'lun'| 'luo'| 'lus'| 'luy'| 'lv'| 'lzh'| 'lzz'| 'mad'
| 'maf'| 'mag'| 'mai'| 'mak'| 'man'| 'mas'| 'mde'| 'mdf'| 'mdr'| 'men'| 'mer'
| 'mfe'| 'mg'| 'mga'| 'mgh'| 'mgo'| 'mh'| 'mhn'| 'mi'| 'mic'| 'min'| 'mk'
| 'ml'| 'mn'| 'mnc'| 'mni'| 'moe'| 'moh'| 'mos'| 'mr'| 'mrj'| 'ms'| 'mt'
| 'mua'| 'mul'| 'mus'| 'mwl'| 'mwr'| 'mwv'| 'my'| 'mye'| 'myv'| 'mzn'| 'na'
| 'nan'| 'nap'| 'naq'| 'nb'| 'nd'| 'nds'| 'nds-NL'| 'ne'| 'new'| 'ng'| 'nia'
| 'niu'| 'njo'| 'nl'| 'nl-BE'| 'nmg'| 'nn'| 'nnh'| 'no'| 'nog'| 'non'| 'nov'
| 'nqo'| 'nr'| 'nso'| 'nus'| 'nv'| 'nwc'| 'ny'| 'nym'| 'nyn'| 'nyo'| 'nzi'
| 'oc'| 'oj'| 'ojb'| 'ojc'| 'ojs'| 'ojw'| 'oka'| 'om'| 'or'| 'os'| 'osa'
| 'ota'| 'pa'| 'pag'| 'pal'| 'pam'| 'pap'| 'pau'| 'pcd'| 'pcm'| 'pdc'| 'pdt'
| 'peo'| 'pfl'| 'phn'| 'pi'| 'pis'| 'pl'| 'pms'| 'pnt'| 'pon'| 'pqm'| 'prg'
| 'pro'| 'ps'| 'pt'| 'pt-BR'| 'pt-PT'| 'qu'| 'quc'| 'qug'| 'raj'| 'rap'| 'rar'
| 'rgn'| 'rhg'| 'rif'| 'rm'| 'rn'| 'ro'| 'ro-MD'| 'rof'| 'rom'| 'rtm'| 'ru'
| 'rue'| 'rug'| 'rup'| 'rw'| 'rwk'| 'sa'| 'sad'| 'sah'| 'sam'| 'saq'| 'sas'
| 'sat'| 'saz'| 'sba'| 'sbp'| 'sc'| 'scn'| 'sco'| 'sd'| 'sdc'| 'sdh'| 'se'
| 'see'| 'seh'| 'sei'| 'sel'| 'ses'| 'sg'| 'sga'| 'sgs'| 'sh'| 'shi'| 'shn'
| 'shu'| 'si'| 'sid'| 'sk'| 'skr'| 'sl'| 'slh'| 'sli'| 'sly'| 'sm'| 'sma'
| 'smj'| 'smn'| 'sms'| 'sn'| 'snk'| 'so'| 'sog'| 'sq'| 'sr'| 'sr-ME'| 'srn'
| 'srr'| 'ss'| 'ssy'| 'st'| 'stq'| 'str'| 'su'| 'suk'| 'sus'| 'sux'| 'sv'
| 'sw'| 'sw-CD'| 'swb'| 'syc'| 'syr'| 'szl'| 'ta'| 'tce'| 'tcy'| 'te'| 'tem'
| 'teo'| 'ter'| 'tet'| 'tg'| 'tgx'| 'th'| 'tht'| 'ti'| 'tig'| 'tiv'| 'tk'
| 'tkl'| 'tkr'| 'tl'| 'tlh'| 'tli'| 'tly'| 'tmh'| 'tn'| 'to'| 'tog'| 'tok'
| 'tpi'| 'tr'| 'tru'| 'trv'| 'trw'| 'ts'| 'tsd'| 'tsi'| 'tt'| 'ttm'| 'ttt'
| 'tum'| 'tvl'| 'tw'| 'twq'| 'ty'| 'tyv'| 'tzm'| 'udm'| 'ug'| 'uga'| 'uk'
| 'umb'| 'und'| 'ur'| 'uz'| 'vai'| 've'| 'vec'| 'vep'| 'vi'| 'vls'| 'vmf'
| 'vmw'| 'vo'| 'vot'| 'vro'| 'vun'| 'wa'| 'wae'| 'wal'| 'war'| 'was'| 'wbp'
| 'wo'| 'wuu'| 'xal'| 'xh'| 'xmf'| 'xnr'| 'xog'| 'yao'| 'yap'| 'yav'| 'ybb'
| 'yi'| 'yo'| 'yrl'| 'yue'| 'za'| 'zap'| 'zbl'| 'zea'| 'zen'| 'zgh'| 'zh'
| 'zh-Hans'| 'zh-Hant'| 'zu'| 'zun'| 'zxx'| 'zza');

/** @public */
export type ScriptIdType = (
  'Adlm'| 'Afak'| 'Aghb'| 'Ahom'| 'Arab'| 'Aran'| 'Armi'| 'Armn'| 'Avst'
| 'Bali'| 'Bamu'| 'Bass'| 'Batk'| 'Beng'| 'Bhks'| 'Blis'| 'Bopo'| 'Brah'
| 'Brai'| 'Bugi'| 'Buhd'| 'Cakm'| 'Cans'| 'Cari'| 'Cham'| 'Cher'| 'Chrs'
| 'Cirt'| 'Copt'| 'Cpmn'| 'Cprt'| 'Cyrl'| 'Cyrs'| 'Deva'| 'Diak'| 'Dogr'
| 'Dsrt'| 'Dupl'| 'Egyd'| 'Egyh'| 'Egyp'| 'Elba'| 'Elym'| 'Ethi'| 'Gara'
| 'Geok'| 'Geor'| 'Glag'| 'Gong'| 'Gonm'| 'Goth'| 'Gran'| 'Grek'| 'Gujr'
| 'Gukh'| 'Guru'| 'Hanb'| 'Hang'| 'Hani'| 'Hano'| 'Hans'| 'Hant'| 'Hatr'
| 'Hebr'| 'Hira'| 'Hluw'| 'Hmng'| 'Hmnp'| 'Hrkt'| 'Hung'| 'Inds'| 'Ital'
| 'Jamo'| 'Java'| 'Jpan'| 'Jurc'| 'Kali'| 'Kana'| 'Kawi'| 'Khar'| 'Khmr'
| 'Khoj'| 'Kits'| 'Knda'| 'Kore'| 'Kpel'| 'Krai'| 'Kthi'| 'Lana'| 'Laoo'
| 'Latf'| 'Latg'| 'Latn'| 'Lepc'| 'Limb'| 'Lina'| 'Linb'| 'Lisu'| 'Loma'
| 'Lyci'| 'Lydi'| 'Mahj'| 'Maka'| 'Mand'| 'Mani'| 'Marc'| 'Maya'| 'Medf'
| 'Mend'| 'Merc'| 'Mero'| 'Mlym'| 'Modi'| 'Mong'| 'Moon'| 'Mroo'| 'Mtei'
| 'Mult'| 'Mymr'| 'Nagm'| 'Nand'| 'Narb'| 'Nbat'| 'Newa'| 'Nkgb'| 'Nkoo'
| 'Nshu'| 'Ogam'| 'Olck'| 'Onao'| 'Orkh'| 'Orya'| 'Osge'| 'Osma'| 'Ougr'
| 'Palm'| 'Pauc'| 'Perm'| 'Phag'| 'Phli'| 'Phlp'| 'Phlv'| 'Phnx'| 'Plrd'
| 'Prti'| 'Qaag'| 'Rjng'| 'Rohg'| 'Roro'| 'Runr'| 'Samr'| 'Sara'| 'Sarb'
| 'Saur'| 'Sgnw'| 'Shaw'| 'Shrd'| 'Sidd'| 'Sind'| 'Sinh'| 'Sogd'| 'Sogo'
| 'Sora'| 'Soyo'| 'Sund'| 'Sunu'| 'Sylo'| 'Syrc'| 'Syre'| 'Syrj'| 'Syrn'
| 'Tagb'| 'Takr'| 'Tale'| 'Talu'| 'Taml'| 'Tang'| 'Tavt'| 'Telu'| 'Teng'
| 'Tfng'| 'Tglg'| 'Thaa'| 'Thai'| 'Tibt'| 'Tirh'| 'Tnsa'| 'Todr'| 'Toto'
| 'Tutg'| 'Ugar'| 'Vaii'| 'Visp'| 'Vith'| 'Wara'| 'Wcho'| 'Wole'| 'Xpeo'
| 'Xsux'| 'Yezi'| 'Yiii'| 'Zanb'| 'Zinh'| 'Zmth'| 'Zsye'| 'Zsym'| 'Zxxx'
| 'Zyyy'| 'Zzzz');

/** @public */
export type RegionIdType = (
  '001'| '002'| '003'| '005'| '009'| '011'| '013'| '014'| '015'| '017'| '018'
| '019'| '021'| '029'| '030'| '034'| '035'| '039'| '053'| '054'| '057'| '061'
| '142'| '143'| '145'| '150'| '151'| '154'| '155'| '202'| '419'| 'AC'| 'AD'
| 'AE'| 'AF'| 'AG'| 'AI'| 'AL'| 'AM'| 'AO'| 'AQ'| 'AR'| 'AS'| 'AT'| 'AU'| 'AW'
| 'AX'| 'AZ'| 'BA'| 'BB'| 'BD'| 'BE'| 'BF'| 'BG'| 'BH'| 'BI'| 'BJ'| 'BL'| 'BM'
| 'BN'| 'BO'| 'BQ'| 'BR'| 'BS'| 'BT'| 'BV'| 'BW'| 'BY'| 'BZ'| 'CA'| 'CC'| 'CD'
| 'CF'| 'CG'| 'CH'| 'CI'| 'CK'| 'CL'| 'CM'| 'CN'| 'CO'| 'CP'| 'CQ'| 'CR'| 'CU'
| 'CV'| 'CW'| 'CX'| 'CY'| 'CZ'| 'DE'| 'DG'| 'DJ'| 'DK'| 'DM'| 'DO'| 'DZ'| 'EA'
| 'EC'| 'EE'| 'EG'| 'EH'| 'ER'| 'ES'| 'ET'| 'EU'| 'EZ'| 'FI'| 'FJ'| 'FK'| 'FM'
| 'FO'| 'FR'| 'GA'| 'GB'| 'GD'| 'GE'| 'GF'| 'GG'| 'GH'| 'GI'| 'GL'| 'GM'| 'GN'
| 'GP'| 'GQ'| 'GR'| 'GS'| 'GT'| 'GU'| 'GW'| 'GY'| 'HK'| 'HM'| 'HN'| 'HR'| 'HT'
| 'HU'| 'IC'| 'ID'| 'IE'| 'IL'| 'IM'| 'IN'| 'IO'| 'IQ'| 'IR'| 'IS'| 'IT'| 'JE'
| 'JM'| 'JO'| 'JP'| 'KE'| 'KG'| 'KH'| 'KI'| 'KM'| 'KN'| 'KP'| 'KR'| 'KW'| 'KY'
| 'KZ'| 'LA'| 'LB'| 'LC'| 'LI'| 'LK'| 'LR'| 'LS'| 'LT'| 'LU'| 'LV'| 'LY'| 'MA'
| 'MC'| 'MD'| 'ME'| 'MF'| 'MG'| 'MH'| 'MK'| 'ML'| 'MM'| 'MN'| 'MO'| 'MP'| 'MQ'
| 'MR'| 'MS'| 'MT'| 'MU'| 'MV'| 'MW'| 'MX'| 'MY'| 'MZ'| 'NA'| 'NC'| 'NE'| 'NF'
| 'NG'| 'NI'| 'NL'| 'NO'| 'NP'| 'NR'| 'NU'| 'NZ'| 'OM'| 'PA'| 'PE'| 'PF'| 'PG'
| 'PH'| 'PK'| 'PL'| 'PM'| 'PN'| 'PR'| 'PS'| 'PT'| 'PW'| 'PY'| 'QA'| 'QO'| 'RE'
| 'RO'| 'RS'| 'RU'| 'RW'| 'SA'| 'SB'| 'SC'| 'SD'| 'SE'| 'SG'| 'SH'| 'SI'| 'SJ'
| 'SK'| 'SL'| 'SM'| 'SN'| 'SO'| 'SR'| 'SS'| 'ST'| 'SV'| 'SX'| 'SY'| 'SZ'| 'TA'
| 'TC'| 'TD'| 'TF'| 'TG'| 'TH'| 'TJ'| 'TK'| 'TL'| 'TM'| 'TN'| 'TO'| 'TR'| 'TT'
| 'TV'| 'TW'| 'TZ'| 'UA'| 'UG'| 'UM'| 'UN'| 'US'| 'UY'| 'UZ'| 'VA'| 'VC'| 'VE'
| 'VG'| 'VI'| 'VN'| 'VU'| 'WF'| 'WS'| 'XA'| 'XB'| 'XK'| 'YE'| 'YT'| 'ZA'| 'ZM'
| 'ZW'| 'ZZ');
